import React, { createContext, useState } from 'react'
import { useDidUpdateEffect } from '@mc/design-system'
import { useStaticData } from './useStaticData'

const initialValue: Record<string, unknown> = {}
const StaticDataContext = createContext(initialValue)
export default StaticDataContext

type ProviderProps = {
  children?: React.ReactNode
  providerKey?: string
  value: Record<string, unknown>
}

export const StaticDataProvider = ({
  value,
  providerKey,
  children,
}: ProviderProps) => {
  const parentData = useStaticData() ?? {}
  const [staticData, setStaticData] = useState({ ...parentData, ...value })

  useDidUpdateEffect(
    () =>
      setStaticData({
        ...parentData,
        ...value,
      }),
    [providerKey, parentData],
  )

  return (
    <StaticDataContext.Provider value={staticData}>
      {children}
    </StaticDataContext.Provider>
  )
}
